import { useEffect } from "react";

export const useKeyboardScrollFix = () => {
  useEffect(() => {
    const isMobileOrTablet = () => {
      const maxSide = Math.max(window.innerWidth, window.innerHeight);
      return maxSide <= 1400;
    };

    let prevViewportHeight = window.innerHeight;
    let scrollTimeout = null;

    const tryScrollToTop = () => {
      if (scrollTimeout) clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
      }, 50);
    };

    const handleFocusIn = (e) => {
      const target = e.target;
      if (
        (target.tagName === "INPUT" || target.tagName === "TEXTAREA") &&
        isMobileOrTablet()
      ) {
        document.body.classList.add("keyboard-open");
        prevViewportHeight =
          window.visualViewport?.height || window.innerHeight;
      }
    };

    const handleFocusOut = () => {
      if (!isMobileOrTablet()) return;

      setTimeout(() => {
        document.body.classList.remove("keyboard-open");

        if (window.scrollY > 0) {
          window.scrollTo(0, 0);
        }
      }, 150);
    };

    const handleResize = () => {
      if (
        isMobileOrTablet() &&
        document.body.classList.contains("keyboard-open") &&
        (window.visualViewport?.height || window.innerHeight) >=
          prevViewportHeight
      ) {
        document.body.classList.remove("keyboard-open");
        tryScrollToTop();
      }
    };

    document.addEventListener("focusin", handleFocusIn);
    document.addEventListener("focusout", handleFocusOut);
    window.visualViewport?.addEventListener("resize", handleResize);

    return () => {
      document.removeEventListener("focusin", handleFocusIn);
      document.removeEventListener("focusout", handleFocusOut);
      window.visualViewport?.removeEventListener("resize", handleResize);
      if (scrollTimeout) clearTimeout(scrollTimeout);
    };
  }, []);
};
